// "YYYY-MM-DD" ↔ seconds for DatePicker (noon avoids a timezone shifting the day).
export function isoToSeconds(iso?: string): number | null {
  return iso ? Math.floor(new Date(iso + "T12:00:00").getTime() / 1000) : null;
}

export function secondsToIso(seconds: number): string {
  const d = new Date(seconds * 1000);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
